import { Component, forwardRef, StaticProvider } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlBase } from "../control-base";

const DoBValueAccessor = <StaticProvider>{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DobControlComponent),
    multi: true
};

@Component({
    selector: "m-dob-control",
    template: '<p-calendar [disabled]="disabled" [showIcon]="true" [(ngModel)]="dateOfBirth" (onBlur)="_onBlur()"></p-calendar>',
    providers: [DoBValueAccessor]
})
export class DobControlComponent extends ControlBase<Date> {
    private _dateOfBirth: Date;

    get dateOfBirth() {
        return this._dateOfBirth;
    }

    set dateOfBirth(dateOfBirth: Date) {
        this._dateOfBirth = dateOfBirth;
        this.onChange(this._dateOfBirth);
    }

    writeValue(obj: Date): void {
        this._dateOfBirth = obj;
    }
}
